import { forwardRef } from "react";
import { Switch as MuiSwitch, FormControl, FormControlLabel, Tooltip, IconButton } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

import { SwitchProps } from "./types";
import { useSwitch } from "./controller";

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ name, label, value, required, instructions, ...rest }, ref) => {
    const {
      checked,
      showInstructions,
      setShowInstructions,
      handleClickShowInstructions
    } = useSwitch({ value });

    return (
      <FormControl required={required}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel
            label={label}
            control={
              <MuiSwitch
                name={name}
                checked={checked}
                inputRef={ref}
                {...rest}
              />
            }
          />

          {instructions && (
            <Tooltip
              title={instructions}
              open={showInstructions}
              onClose={() => setShowInstructions(false)}
              arrow
            >
              <IconButton
                aria-label="show instructions"
                onClick={handleClickShowInstructions}
                size="small"
              >
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </FormControl>
    );
  }
);

Switch.displayName = "Switch";
